import { render, staticRenderFns } from "./ContractorDetail.vue?vue&type=template&id=13b463a3&scoped=true&"
import script from "./ContractorDetail.vue?vue&type=script&lang=ts&"
export * from "./ContractorDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ContractorDetail.vue?vue&type=style&index=0&id=13b463a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b463a3",
  null
  
)

export default component.exports